import React, { useState } from 'react';
import { HelpCircle, X } from 'lucide-react';
import CrisisResources from './CrisisResources';

const SafetyButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Floating Safety Button */}
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-6 left-4 z-40 flex items-center gap-2 px-4 py-2 rounded-full shadow-lg transition-all hover:scale-105 active:scale-95 md:bottom-8"
        style={{ 
          backgroundColor: 'rgba(201,168,76,0.9)',
          color: '#FBF9F6',
          fontFamily: 'Jost, sans-serif',
          fontSize: '14px',
          fontWeight: '500',
          backdropFilter: 'blur(10px)',
          minHeight: '44px'
        }}
        data-testid="safety-button"
        aria-label="Get help - Crisis resources"
      >
        <HelpCircle className="w-4 h-4" />
        <span>Help</span>
      </button>

      {/* Crisis Resources Modal */}
      {isOpen && (
        <div className="fixed inset-0 z-50">
          {/* Backdrop */}
          <div 
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            onClick={() => setIsOpen(false)}
          />
          
          {/* Modal Content */}
          <div className="relative h-full overflow-auto">
            <CrisisResources isModal={true} onClose={() => setIsOpen(false)} />
          </div>
        </div>
      )}
    </>
  );
};

export default SafetyButton;
